import * as React from "react"
import { createRoot } from "react-dom/client"
import { App } from "../org-admins/org-admins-app"

const rootEl = document.getElementById("org-admins-root")
if (rootEl) {
  console.log("found root")
  const root = createRoot(rootEl)
  root.render(<App />)
} else {
  console.error("missing org-admins-root element")
}
